<div #blockRef class="block" [class.pagebreakbefore]="block.pagebreak == 'Y'">

  <div class="title" [class.no-print]=" block.fragment_id === 14">
    @if (!blockReady && block.fragment_id !==3) {
      <i class="fa fa-refresh fa-spin"></i>
      } {{block.title}}
    </div>

    @if (data) {
      @if (block.fragment_id === 1) {
        <div>
          @for (item of refresh; track item) {
            <div>
              <!--  hack to refresh chart -->
              @if (data) {
                <p-chart class="4d-{{item}}" type="line" [data]="data"></p-chart>
              }
            </div>
          }
        </div>
      }
      @if (block.fragment_id === 2) {
        <div>
          <app-report-weather-table [config]="master" [data]="data"></app-report-weather-table>
        </div>
      }
      @if ((block.fragment_id >= 3 && block.fragment_id <= 5)) {
        <div>
          @for (item of refresh; track item) {
            <div>
              <!--  hack to refresh chart -->
              <app-report-count-by-day [(blockReady)]="blockReady" [reportBlock]="block" [config]="master" [data]="data">
              </app-report-count-by-day>
            </div>
          }
        </div>
      }
      @if (block.fragment_id === 6) {
        <div>
          <app-report-telemetry-by-day [config]="master" [data]="data"></app-report-telemetry-by-day>
        </div>
      }
      @if ((block.fragment_id === 7 || block.fragment_id === 8 || block.fragment_id === 15)) {
        <div>
          <app-report-telemetry-min-max [config]="master" [data]="data"></app-report-telemetry-min-max>
        </div>
      }
      @if (block.fragment_id === 14) {
        <div>
          <app-report-monthly [config]="master" [data]="data"></app-report-monthly>
        </div>
      }
      @if ((block.fragment_id === 99) ) {
        <div>
          <app-report-text [reportBlock]="block" [config]="master" [data]="data"></app-report-text>
        </div>
      }
    }
  </div>
